<template>
  <div class="totelMoney">
    <div v-if="asset" class="totelTitle bg-black">
      <img :src="titleImg" class="totel-img">
      <div class="totelTitle-left">
        <div class="asset-font">
          <span>总资产 (元)</span>
          <span class="asset-crash" @click="goCrash(1)">申请提现</span>
        </div>
        <div class="asset-num">
          {{total | fixed}}
        </div>
      </div>
    </div>
    <div v-else class="totelTitle bg-white">
      <div class="totelTitle-item">
                <span class="totelTitle-item-content">
                    <span class="item-title">总资产 (元)</span>
                    <span class="item-content">
                        <span class="item-money">{{homeTopInfo.account | fixed}}</span>
                        <span class="item-button" @click="goCrash(2)">提现</span>
                    </span>
                </span>
        <img :src="imgUrl1" class="item-img">
      </div>
      <div class="totelTitle-item bg44">
                <span class="totelTitle-item-content">
                    <span class="item-title">日成交量 (笔)</span>
                    <span class="item-content">
                        <span class="item-money">{{homeTopInfo.count}}</span>
                    </span>
                </span>
        <img :src="imgUrl2" class="item-img">
      </div>
      <div class="totelTitle-item bg6F">
                <span class="totelTitle-item-content">
                    <span class="item-title">日成交额 (元)</span>
                    <span class="item-content">
                        <span class="item-money">{{homeTopInfo.sum | fixed}}</span>
                    </span>
                </span>
        <img :src="imgUrl3" class="item-img">
      </div>
    </div>
  </div>
</template>

<script>

  import homeTotel from '../assets/images/home-totel.png'
  import homeMoney from '../assets/images/home-money.png'
  import homeCount from '../assets/images/home-count.png'
  import pig from '../assets/images/assert-pig.png'
  import bus from '@/utils/BusEvent'
  import { mapGetters } from 'vuex'
  import { mayWithdrawal, putWithdrawl } from "@/api/withdraw";
  export default {
    props: ['asset'],
    data () {
      return {
        imgUrl1: homeTotel,
        imgUrl2: homeCount,
        imgUrl3: homeMoney,
        titleImg: pig,
        total:0
      }
    },
    computed: {
      ...mapGetters([
        'homeTopInfo'
      ])
    },
    mounted () {
      this.mchId = this.$store.getters.mchId;
    mayWithdrawal(this.mchId)
      .then(res => {
        let { mayAccount, feeRate, account,thirdAccount,day,date,invoiceFreeAccount } = res.data;
        this.total = parseFloat(account+thirdAccount).toFixed(2);
       
      })
      .catch(err => {});
    },
    methods: {
      goCrash: function (id) {
        this.$router.push({
          path: id == 1 ? 'indexshow/withdraw' : 'main/indexshow/withdraw'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../style/mixin';
  @import '../style/_variables';

  .totelMoney {
    // background-color: $totel-bg;
    background-color: #fff;
    height: 100%;
    > .totelTitle {
      height: 100%;
      @include flex-row;
      // justify-content: space-around;
      font-size: $totel-font-size;
      color: $totel-font-color;
      > .totelTitle-left {
        flex-direction: column;
        justify-content: center;
        margin-right: 50px;
        margin-left: 20px;

        > .totelTitle-num {
          font-size: $totel-num-size;

        }
        > .asset-num {
          font-size: 48px;
          margin-top: 10px;
        }
        > .home-num {
          font-size: $totel-num-size;
          @include flex-row;
          > .totel-img {
            width: $totel-img-width;
            height: $totel-img-height;
            margin-right: 10px;
          }
        }
        > .home-font {
          margin-top: 20px;
        }
        > .asset-font {
          @include flex-row;
          font-size: 20px;
          > .totel-img {
            width: $totel-img-width;
            height: $totel-img-height;
            margin-right: 10px;
          }
          > .asset-crash {
            display: inline-block;
            margin-left: 14px;
            width: 88px;
            height: 26px;
            font-size: 17px;
            background-color: #edda02;
            border-radius: 20px;
            text-align: center;
            // align-self: center;
            line-height: 26px;
            cursor: pointer;
          }
        }
      }

      > .totelTitle-item {
        flex: 1;
        height: 100px;
        margin-right: 10px;
        margin-left: 10px;
        background-color: #8197ff;
        @include flex-row;
        justify-content: space-between;
        > .totelTitle-item-content {
          @include flex-column;
          align-items: flex-start;
          padding-left: 20px;
          > .item-title {
            font-size: 16px;
          }
          > .item-content {
            @include flex-row;
            justify-content: space-between;
            > .item-money {
              font-size: 30px;
              font-weight: bold;
            }
            > .item-button {
              margin-left: 14px;
              width: 50px;
              display: inline-block;
              border: 1px solid #fff;
              border-radius: 4px;
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              text-align: center;
              cursor: pointer;
            }
          }

        }
        > .item-img {
          width: 100px;
          height: 100px;
        }
      }
      > .bg44 {
        background-color: #44dd8e;
      }
      > .bg6F {
        background-color: #6FCAEC;
      }
    }
    > .bg-white {
      background-color: #fff;
      // margin: 10px 0;
    }
    > .bg-black {
      height: 184px;
      background: url(../assets/images/assetBg.png) no-repeat;
      background-size: 100% 100%;
      margin: 0 20px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TotelMoney.vue